import angular from 'angular';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  actionIcon,
  confirmDialog,
  downloadDocument,
} from 'app/components/global';
import controller from './test-document.controller';
import directive from './test-document.directive';
import editTestDocumentDialog from '../../testDocuments/dialog.editTestDocumentDialog';

export default angular.module('app.components.advisory.bcp.testDocument', [
  alerts,
  actionIcon,
  bcpDataService,
  confirmDialog,
  downloadDocument,
  ssDialogService,
  editTestDocumentDialog,
])
  .directive('bcpTestDocument', directive)
  .controller('TestDocumentController', controller)
  .name;

console.log('app.components.advisory.bcp.testDocument created');
